// VoK MUI base styles
import borders from "app/assets/theme/base/borders";
import boxShadows from "app/assets/theme/base/boxShadows";

const {borderRadius} = borders;
const {xxl} = boxShadows;

const dialog = {
    styleOverrides: {
        paper: {
            borderRadius: borderRadius.lg,
            boxShadow: xxl,
        },

        paperFullScreen: {
            borderRadius: 0,
        },
    },
};

export default dialog;
